import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { OnboardingSteps } from "../../utils/constants";
import WelcomePage from "../onboarding/WelcomePage/WelcomePage";
import FindFriendsPage from "../onboarding/FindFriendsPage/FindFriendsPage";
import GetAppPage from "../onboarding/GetAppPage/GetAppPage";
import InsuranceBonusPage from "../onboarding/InsuranceBonusPage/InsuranceBonusPage";
import GetAppAfterBonusPage from "../onboarding/GetAppAfterBonusPage/GetAppAfterBonusPage";
import JoinCommunityPage from "../onboarding/JoinCommunityPage/JoinCommunityPage";
import InstallTestflightPage from "../onboarding/InstallTestflightPage/InstallTestflightPage";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import { renderHeaders } from "../../utils/renderHeaders";

function SignUpWelcomeFlowPage() {
  const { currentStep, goToStep } = useOnboardingSteps();
  const { t } = useTranslation();

  useEffect(() => {
    if (currentStep === OnboardingSteps.TURN_ON_NOTIFICATIONS) {
      goToStep(OnboardingSteps.VIEW_INSURANCE_BONUS);
    }
  }, [currentStep, goToStep]);

  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.VIEW_WELCOME:
      contentEl = <WelcomePage />;
      break;
    case OnboardingSteps.FIND_FRIENDS:
      contentEl = <FindFriendsPage />;
      break;
    case OnboardingSteps.JOIN_COMMUNITY:
      contentEl = <JoinCommunityPage />;
      break;
    case OnboardingSteps.GET_APP:
      contentEl = <GetAppPage />;
      break;
    case OnboardingSteps.INSTALL_TEST_FLIGHT:
      contentEl = <InstallTestflightPage />;
      break;
    case OnboardingSteps.TURN_ON_NOTIFICATIONS:
    case OnboardingSteps.VIEW_INSURANCE_BONUS:
      contentEl = <InsuranceBonusPage />;
      break;
    case OnboardingSteps.GET_APP_AFTER_BONUS:
      contentEl = <GetAppAfterBonusPage />;
      break;
    default:
      contentEl = <WelcomePage />;
  }

  return (
    <>
      {renderHeaders({
        title: t("metadata:welcome_to_fun_games_hyper_gaming_app"),
        description: t("metadata:sign_up_welcome_seo_description"),
        ogTitle: t("metadata:win_cash_in_1v1_and_multiplayer_games"),
      })}
      {contentEl}
    </>
  );
}

export default SignUpWelcomeFlowPage;
